var _rect, _path, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullBleedNormalHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 111,
    viewBox: "0 0 156 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7322_24733)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    transform: "translate(0 0.562378)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7322_24733)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7322_24733)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7322_24733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -30,
    y: 0,
    width: 216,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.727 0.106079H-26.7273C-28.5348 0.106079 -30 1.56659 -30 3.36822V107.757C-30 109.558 -28.5348 111.019 -26.7273 111.019H182.727C184.535 111.019 186 109.558 186 107.757V3.36822C186 1.56659 184.535 0.106079 182.727 0.106079Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7322_24733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.727 0.106079H-26.7273C-28.5348 0.106079 -30 1.56659 -30 3.36822V107.757C-30 109.558 -28.5348 111.019 -26.7273 111.019H182.727C184.535 111.019 186 109.558 186 107.757V3.36822C186 1.56659 184.535 0.106079 182.727 0.106079Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.696 71.1102C157.497 71.2205 189.366 92.4193 199.83 94.8484C210.296 97.2775 206.966 111.299 206.966 111.299H38.3418C38.3418 111.299 97.5621 78.9495 104.46 80.6056C111.357 82.2618 110.405 86.0156 116.351 86.126C122.297 86.2365 139.897 71 148.696 71.1102Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26172 55.8812C-3.38974 56.0333 -23.8571 85.2649 -30.5777 88.6144C-37.2984 91.9641 -35.16 111.299 -35.16 111.299H73.1338C73.1338 111.299 35.1011 66.691 30.6716 68.9748C26.2421 71.2585 26.8533 76.4346 23.0347 76.5869C19.216 76.7393 7.91317 55.7292 2.26172 55.8812Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.098 81.9287C145.446 82.0092 124.979 97.5017 118.259 99.2768C111.538 101.052 113.676 111.299 113.676 111.299H221.97C221.97 111.299 183.937 87.6576 179.508 88.868C175.079 90.0784 175.69 92.8217 171.871 92.9024C168.052 92.9832 156.749 81.8481 151.098 81.9287Z",
    fill: "#D9D9D9"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 0.179688,
    y: 0.562378,
    width: 155.64,
    height: 18.6552,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 60.8291,
    y: 44.0746,
    width: 34.202,
    height: 7.2085,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 58.9678,
    y: 54.829,
    width: 38.0641,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 56.5176,
    y: 59.0472,
    width: 42.9645,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 64.5645,
    y: 63.2655,
    width: 26.8707,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 142.543,
    y: 10.9829,
    width: 9.55969,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 130.636,
    y: 10.9829,
    width: 9.55969,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 118.44,
    y: 10.9829,
    width: 9.55969,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 4.5376,
    y: 8.57678,
    width: 30.8208,
    height: 7.48462,
    rx: 1,
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7322_24733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    fill: "white",
    transform: "translate(0 0.562378)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7322_24733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    fill: "white",
    transform: "translate(0 0.562378)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7322_24733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 112,
    fill: "white",
    transform: "translate(-30 -0.437622)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBleedNormalHeader);
export default __webpack_public_path__ + "static/media/full-bleed-normal-header.e574048f0218f7ae8e6187b6b5202be7.svg";
export { ForwardRef as ReactComponent };